// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HeaderLogo-module__container--oCkXz{width:11.278rem}.HeaderLogo-module__image--S4rmY{display:block;height:auto;width:100%}", "",{"version":3,"sources":["webpack://./src/components/HeaderLogo/HeaderLogo.module.scss"],"names":[],"mappings":"AAAA,qCACE,eAAA,CAGF,iCACE,aAAA,CACA,WAAA,CACA,UAAA","sourcesContent":[".container {\n  width: 11.278rem;\n}\n\n.image {\n  display: block;\n  height: auto;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "HeaderLogo-module__container--oCkXz",
	"image": "HeaderLogo-module__image--S4rmY"
};
export default ___CSS_LOADER_EXPORT___;
